import { render, staticRenderFns } from "./MainSideMenu.vue?vue&type=template&id=633fa715&scoped=true&"
import script from "./MainSideMenu.vue?vue&type=script&lang=js&"
export * from "./MainSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./MainSideMenu.vue?vue&type=style&index=0&id=633fa715&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633fa715",
  null
  
)

export default component.exports